
import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import SwaggerUI from './SwaggerComponent';
import { RedocStandalone } from 'redoc';
class App extends Component {
  render() {

    return (
      <div className="App" >
        <RedocStandalone 
        specUrl="https://movie-apidoc.firebaseapp.com/openapi.json" />
      </div>
    );
  }
}

export default App;
